import styled from "styled-components";

export const ModalTermStyled = styled.div`
  .modal {
    position: fixed;
    left: 0;
    right: 0;
    width: 80%;
    height: 80%;
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    border-radius: 8px;
    padding: 20px;
    max-width: 800px;
    max-height: 100%;
    overflow-y: auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  h1 {
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
    color: var(--color-white-fixed);
  }

  h2 {
    font-size: 18px;
	font-weight: bold;
    margin-top: 20px;
    color: var(--color-white-fixed);
  }

  p {
    font-size: 16px;
    color: var(--color-white-fixed);
    line-height: 1.5;
  }
`;
